/** @format */

import {ChartLabelList, CommonChartData} from '../../model/charts';

import {getChartLabelValue} from './getChartLabelValue';
import {findExtremes} from './findExtremes';
import {BrushStartEndIndex} from '../../model/common';

/**
 * Точка входа в процесс вычисления подписей к значениям графика.
 * @param chartData
 */

interface Options {
  chartData: CommonChartData[];
  brushIndex?: Required<BrushStartEndIndex>;
  maxPeakLabels: number;
  maxPitLabels: number;
}

const computeLabels = ({
  chartData,
  brushIndex,
  maxPeakLabels,
  maxPitLabels,
}: Options): ChartLabelList | undefined => {
  if (!chartData.length) {
    return;
  }

  // Берем срез значений

  let slicedData = chartData;

  if (brushIndex) {
    // нормализуем границы среза
    const from = Math.max(0, brushIndex.startIndex);
    const to = Math.min(brushIndex.endIndex, chartData.length - 1);

    // если после нормализации интервал пустой, вернём пустой список
    if (from > to) {
      return;
    }

    slicedData = chartData.slice(from, to + 1);
  }

  // На этом этапе вычисляем весь список и координаты подписей (без экстремумов)

  const result: ChartLabelList = {};

  slicedData.forEach((chart, index, arr) => {
    const labelPrimary = getChartLabelValue({
      data: arr,
      index,
      key: 'primary',
    });
    const labelSecondary = getChartLabelValue({
      data: arr,
      index,
      key: 'secondary',
    });

    if (!labelPrimary && !labelSecondary) {
      return;
    }

    result[chart.name] = {
      primary: labelPrimary || {show: false},
      ...(labelSecondary && {secondary: labelSecondary}),
    };
  });

  // Фильтруем подписи, находя экстремумы

  return findExtremes({
    data: result,
    maxPitLabels,
    maxPeakLabels,
  });
};

export {computeLabels};
